export const isBloodstockHorseProfile = () => {
    /*
        we check here if we are on bloodstock profile page OR on normal horse profile page
        one of the differences are exactly the logo rendered on both pages
        on both page 2 logos are rendered (one is not visible), but only on bloodstock page one of the logos has href which includes 'bloodstock'
    */
    const logosElements = document.querySelectorAll('[data-test-selector="link-navigationRpLogo"]');
    return Array.from(logosElements)
        .filter(logo => logo.tagName === 'A' && logo.href.includes('bloodstock')).length > 0;
};



// WEBPACK FOOTER //
// ./src/js/utils/isBloodstockHorseProfile.js